module.exports = __webpack_public_path__ + "assets/onboarding-mobile.e629d8256ff0023c71560989cbbe6268.png";